import { Component, Input, ViewChild } from "@angular/core";
import { RoleMgr, ShowRequest } from "../../core";
import { AppTab } from "../../core/app-tab";
import { VolunteerPointsTableComponent } from "./volunteer-points-table.component";

@Component({
  selector: "app-volunteer-point-list",
  templateUrl: "volunteer-point-list.component.html",
})
export class VolunteerPointListComponent {

  @Input() tabConfig: AppTab;

  @Input() detailFn: (vi: ShowRequest) => void;

  @Input() contextJson: string;

  @Input() contextJsonChangeHandler: (itemId: string, tab: AppTab) => void;

  @ViewChild("volPtsTable") taskTable: VolunteerPointsTableComponent;

  bTabSelected = false;

  constructor(public roleMgr: RoleMgr) {}

  // some hacks to type check cell renderer template before checking in
  // Temporarly uncomment in template html to do type checking (don't check in uncommented!!!)
  //typedRecord = (r: VolunteerTaskViewRecord) => r;
  //typedColumn = (c: TableColumn) => c;

}
